import { render } from "./app.vue?vue&type=template&id=55ff2458"
import script from "./app.ts?vue&type=script&lang=js&external"
export * from "./app.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__